import type { SceneContent } from '../../presentation/types';

/** Selected work, not a strategic pillar: one compact scene (Prompt2 §16). */
export const etrust: SceneContent = {
  id: 'etrust',
  shortLabel: 'eTRUST',
  title: 'eTrust — Selected Work',
  seconds: 30,
  brand: 'etrust',
  bridgeIn: 'Alongside its own products, Moderta designs and delivers platforms for others.',
  atmosphere: () => ({ pattern: 'ambient', density: 0.1, opacity: 0.04, cameraZ: 14 }),
  script: {
    title: 'eTrust — Selected Work',
    onScreen: ['SELECTED WORK', 'eTrust', 'Digital ownership beyond the checkout.', 'PRODUCT → OWNERSHIP → WARRANTY → SERVICE', 'ONE CONNECTED PRODUCT JOURNEY.'],
    visual: 'eTrust named at the top, under a SELECTED WORK label. A single product node, then ownership, warranty and service connect to it in a line, and a token travels along the journey.',
    narration: [
      'eTrust is one example: a platform Moderta designed and delivered.',
      'It keeps ownership, warranty and service connected to the product itself, instead of scattered across receipts, cards and separate systems.',
      'One connected product journey.',
    ],
    presenterNotes: [
      'eTrust appears as selected work. One sentence.',
      'Ownership, warranty, service connect.',
      '"One connected product journey." Move on.',
    ],
  },
};
